export default __webpack_public_path__ + "static/media/18.0b718141.png";